import React, { useEffect, createElement } from 'react';
import { META_PIXEL_ID } from './lib/constants';
import { StickyAlertBar } from './components/StickyAlertBar';
import { Hero } from './components/Hero';
import { SalesLetterContainer } from './components/SalesLetterContainer';
import { IntroducingSection } from './components/IntroducingSection';
import { WhatYouGetStack } from './components/WhatYouGetStack';
import { BonusSection } from './components/BonusSection';
import { DynamicPricingOffer } from './components/DynamicPricingOffer';
import { CTABand } from './components/CTABand';
import { FAQ } from './components/FAQ';
import { SocialProofFooter } from './components/SocialProofFooter';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    // Stub fbq so calls before script load are queued
    const w = window as any;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    w.fbq = n;
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Append the pixel script directly to <head>
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
    // <noscript> fallback pixel
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-base font-sans text-ink selection:bg-primary/20" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />

        <div className="w-12 h-px bg-primary/30 mx-auto my-16 md:my-24" data-id="element-4" />

        <SalesLetterContainer data-id="element-5" />

        <CTABand headline="¿Sentís que esto te está hablando a vos?" buttonText="Empezar a moverme suave →" variant="cream" data-id="element-6" />

        <IntroducingSection data-id="element-7" />

        <WhatYouGetStack data-id="element-8" />

        <CTABand headline="Imaginate sentirte así todos los días." buttonText="Quiero MOVÉ SUAVE™ ahora →" variant="sage" data-id="element-9" />

        <BonusSection data-id="element-10" />

        <CTABand headline="Llevate todo + los 7 bonos premium." subline="Valor total $365.999 ARS · Hoy solo $14.999 ARS" buttonText="Acceder ahora con 80% OFF →" variant="cream" data-id="element-11" />

        <DynamicPricingOffer data-id="element-12" />

        <div className="w-12 h-px bg-primary/30 mx-auto my-16 md:my-24" data-id="element-13" />

        <FAQ data-id="element-14" />
      </main>
      <SocialProofFooter data-id="element-15" />
    </div>;
}